var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contract.id)?_c('ViewerItem',{staticClass:"link",attrs:{"type":"Contract","model_id":_vm.contract.id}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.contract.uid)+" ")]},{"contract":_vm.contract})],2):_c('span',[_vm._v("无")])
}
var staticRenderFns = []

export { render, staticRenderFns }